import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import { message } from "antd";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import Cookies from "js-cookie";
class FuelGraphStore {
  fuelGraph = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      fuelGraph: observable,
      total: observable,
      loading: observable,
      loadFuelGraphData: action,
      downloadFuelGraph: action,
    });
    this.rootStore = rootStore;
  }

  async loadFuelGraphData({
    offset,
    limit,
    companyId,
    vehicleId,
    fromDate,
    toDate,
    Date,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
    };

    var response = await postApi.getClient().post("/graph/fuelgraph", postData);
    var FuelGraphData = response?.data?.data?.FuelDetails;
    this.fuelGraph = FuelGraphData;
    return response?.data?.data?.FuelDetails;
  }

  async downloadFuelGraph({
    companyId,
    vehicleId,
    fromDate,
    toDate,
    interval,
  }) {
    try {
      const postData = {
        companyId,
        vehicleId,
        fromDate,
        toDate,
        int: interval,
        page: 1,
        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
      };

      const base64Input = await base64_encode(JSON.stringify(postData));

      try {
        var response = await postApi
          .getClient()
          .post("/fuel_report/fuelrefill/download/pdf", postData, {
            responseType: "blob",
          });

        const blob = new Blob([response.data], {
          type: "application/pdf",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Fuel Graph.pdf";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        message.error("Failed to download the report. Please try again.");
      }

      // try {
      //   var response = await postApi
      //     .getClient()
      //     .post(
      //       "index.php?c=fuel&a=DownloadFuelGraph",
      //       "postData=" + base64Input,
      //       { responseType: "blob" }
      //     );
      //   if (!response || !response.data) {
      //     console.error("Empty response received.");
      //     return;
      //   }

      //   const blob = new Blob([response.data], { type: "application/pdf" });
      //   const url = window.URL.createObjectURL(blob);

      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = "fuel_graph_report.pdf";
      //   document.body.appendChild(a);
      //   a.click();
      //   document.body.removeChild(a);

      //   // Clean up the URL
      //   window.URL.revokeObjectURL(url);
      // } catch (error) {
      //   console.error("Error downloading PDF:", error);
      // }
    } catch (error) {
      console.error("Error downloading Fuel Graph:", error);
    }
  }
}

export default FuelGraphStore;
